import { render } from "./Legal.vue?vue&type=template&id=2596319e&scoped=true&ts=true"
import script from "./Legal.vue?vue&type=script&lang=ts"
export * from "./Legal.vue?vue&type=script&lang=ts"

import "./Legal.vue?vue&type=style&index=0&id=2596319e&lang=scss&scoped=true"

import exportComponent from "D:\\Work\\HESEL\\DCS\\Client\\vuejs-dcs\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2596319e"]])

export default __exports__